import moment from 'moment';

// Keycloak's `preferred_username` claim, falling back to `email`. Never
// falls back to `sub` — that's the user's opaque UUID, not anything
// readable, so it's better to show nothing than to show that.
export const getStoredUsername = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.preferred_username || payload.email || null;
  } catch {
    return null;
  }
};

export const getDefaultDateRange = () => ({
  from: moment().subtract(30, 'days').startOf('day'),
  to: moment().startOf('day')
});

export const createParamsString = (params) => {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

export const calcDecimals = (tick) => {
  if (tick === 0) return 0;
  return tick.toString().split('.')[1]?.length || 0;
};

// Regex pattern for numeric input validation (allows negative numbers and decimal points)
export const NUMERIC_INPUT_REGEX = /^-?\d*(?:[.,]\d*)?$/;

export const normalizeNumericInput = (value) => {
  if (value === '') return '';

  // Replace comma with dot for decimal separator
  let normalized = value.replace(',', '.');

  // Handle special case: "-." becomes "-0."
  if (normalized === '-.') {
    normalized = '-0.';
  }
  // Handle special case: ".number" becomes "0.number"
  else if (normalized.startsWith('.')) {
    normalized = '0' + normalized;
  }

  return normalized;
};
